// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTable-Text_cls1__RbpGS","cls2":"VeloTable-Text_cls2__dh2Es VeloTable-Text_cls1__RbpGS","wrap":"VeloTable-Text_wrap__y0++z"};